import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from '../../../models';
import { AuthService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';

@Component({
    selector: 'sn-usc-top10-result-panel',
    templateUrl: './usc-top10-result-panel.component.html',
    styleUrls: ['./usc-top10-result-panel.component.css']
})
export class UscTop10ResultPanelComponent implements OnInit {
    @Input() max_placements: number;
    @Input() scope_type: string;
    @Input() scope_value: string;
    @Input() control_id: number;
    @Output() public viewChange = new EventEmitter();
    @Input() scope_month: string;
    @Input() mode: string = 'monthly';
    
    public scope_types: any[] = [];
    public initial_max_placements: number;
    public selected_scope_type: any;
    public active_user: User;
    public user_achievement: any;
    public scope_achievement: any;
    public top_placements: any = [];
    public outside_placement: any;
    public show_outside_placement: boolean = false;
    public show_view_more: boolean = false;
    public testing: any;
    public is_store_placement: boolean = false;
    public is_current_month: boolean = true;
    public is_placement_loaded: boolean = false;

    public scope_type_ranking: any = {
        "channel": 0,
        "region": 1,
        "territory": 2,
        "area": 3,
        "store": 4,
    }

    constructor(
        public uscStoreService: UscStoreService,
        public authService: AuthService,
    ) { 
        this.active_user = this.authService.getActive();
        this.current_result_type = this.uscStoreService.isLeader() ? 'store' : 'associate';
        this.view_result_types = this.getAvailableViewResultTypes('associate');
        if (this.uscStoreService.isLeader()) {
            this.is_store_placement = true;
            this.view_result_types = this.getAvailableViewResultTypes('store');
        }
    }

    ngOnInit() {
        this.initial_max_placements = this.max_placements;
        if (this.scope_month == undefined) this.scope_month = this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_current_month = this.scope_month == this.uscStoreService.getThisMonthActionPlanSubject();
        this.updateTopResultData();

        this.uscStoreService.p2wScopeMonth.subscribe(m => {
            if (m.length == 6 && this.scope_month != m) {
                this.scope_month = m;
                this.is_current_month = this.scope_month == this.uscStoreService.getThisMonthActionPlanSubject();
                this.updateTopResultData();
            }
        })
    }

    updateTopResultData() {
        this.is_placement_loaded = false;
        if (this.uscStoreService.isLeader()) {
            this.scope_types = [];
            this.selected_scope_type = { name: "", value:this.scope_type, selected: false }
            var achievements = [];
            if (this.is_current_month) {
                achievements = this.uscStoreService.getConsultantAchievementsByScopeType(this.scope_type, this.scope_value);
            } else {
                achievements = this.uscStoreService.getConsultantAchievementsFromPreviousActionPlans(this.scope_month, this.scope_type, this.scope_value, "quota");
            }
            if (achievements.length > 0) this.scope_achievement = achievements[0];
            if (this.uscStoreService.isUSCellAgent()) {
                this.scope_types.push({ name: "Agency", value:"agency", selected: this.scope_type == "agency" });
                this.scope_types.push({ name: "Store", value:"store", selected: this.scope_type == "store" });
            } else {
                if (this.scope_type_ranking[this.scope_type] >= this.scope_type_ranking["channel"] && this.scope_achievement.channel) this.scope_types.push({ name: "National", value:"channel", selected: this.scope_type == "channel" });
                if (this.scope_type_ranking[this.scope_type] >= this.scope_type_ranking["region"] && this.scope_achievement.region) this.scope_types.push({ name: "Region", value:"region", selected: this.scope_type == "region" });
                if (this.scope_type_ranking[this.scope_type] >= this.scope_type_ranking["territory"] && this.scope_achievement.territory) this.scope_types.push({ name: "Territory", value:"territory", selected: this.scope_type == "territory" });
                if (this.scope_type_ranking[this.scope_type] >= this.scope_type_ranking["area"] && this.scope_achievement.area) this.scope_types.push({ name: "Area", value:"area", selected: this.scope_type == "area" });
                if (this.scope_type_ranking[this.scope_type] >= this.scope_type_ranking["store"] && this.scope_achievement.store) {
                    this.scope_types.push({ name: (this.uscStoreService.isUSCellTelesales() ? "Pod" : "Store"), value:"store", selected: this.scope_type == "store" });
                } 
            }
            this.selected_scope_type = this.scope_types.find(s =>s.selected);
            this.reload();
        } else {
            var user = JSON.parse(JSON.stringify(this.active_user)); 
            this.scope_type = "store"; 
            //this.scope_types = [];
            if (this.is_current_month) {
                this.user_achievement = this.uscStoreService.getConsultantAchievementByUser(user);
                this.scope_types = this.getAvailableScopeTypes();
                this.selected_scope_type = this.scope_types.find(s =>s.selected);
                this.reload();
            } else {
                var action_plan = this.uscStoreService.getPreviousUserActionPlanByMonth(this.active_user, this.scope_month);
                if (action_plan) {
                    var sales_vs_quotas = JSON.parse(action_plan.cs_sales_vs_quotas);
                    this.user_achievement = sales_vs_quotas;
                    this.scope_types = this.getAvailableScopeTypes();
                    this.selected_scope_type = this.scope_types.find(s =>s.selected);
                    this.reload();
                }
            }
        }        
    }

    getAvailableScopeTypes():any {
        var scope_types = [];
        if (this.user_achievement) {
            if (this.uscStoreService.isUSCellAgent()) {
                scope_types.push({ name: "Agency", value:"agency", selected: this.scope_type == "agency" });
                scope_types.push({ name: "Store", value:"store", selected: this.scope_type == "store" });
            } else {
                if (this.user_achievement.channel) scope_types.push({ name: "National", value:"channel", selected: false });
                if (this.user_achievement.region) scope_types.push({ name: "Region", value:"region", selected: this.scope_type == "region" });
                if (this.user_achievement.territory) scope_types.push({ name: "Territory", value:"territory", selected: this.scope_type == "territory" });
                if (this.user_achievement.area) scope_types.push({ name: "Area", value:"area", selected: this.scope_type == "area" });
                if (this.user_achievement.store) scope_types.push({ name: (this.uscStoreService.isUSCellTelesales() ? "Pod" : "Store"), value:"store", selected: this.scope_type == "store" });
            }
            return scope_types;
            //this.selected_scope_type = this.scope_types.find(s =>s.selected);
        }
        return scope_types;
    }

    reload() {
        this.is_placement_loaded = true;
        this.show_outside_placement = false;
        if (this.current_result_type != "associate") {
            this.updateTopStorePlacements();
        } else {
            this.reloadConsultantAchievements();
        }
    }

    reloadConsultantAchievements() {
        if (this.uscStoreService.isLeader()) {
            this.updateTopConsultantPlacements();
        } else {
            if (this.user_achievement) {
                this.updateTopConsultantPlacements(); 
            }       
        }
    }

    scopeChange(s) {
        this.selected_scope_type = s;
        this.reload();
    }

    getSelectedScopeValue() {
        var achievement = (this.uscStoreService.isLeader()) ? this.scope_achievement : this.user_achievement;
        var selected_scope_value = this.scope_value;
        switch (this.selected_scope_type.value) {
            case "area": selected_scope_value = achievement.area; break;
            case "territory": selected_scope_value = achievement.territory; break;
            case "region": selected_scope_value = achievement.region; break;
            case "store": selected_scope_value = achievement.store; break;
            case "agency": selected_scope_value = achievement.agency; break;
            default:
                if (this.uscStoreService.isUSCellCorp()) selected_scope_value = "Corporate";
                if (this.uscStoreService.isUSCellTelesales()) selected_scope_value = "Telesales";
                break;
        }
        return selected_scope_value;
    }

    viewMore() {
        this.max_placements = parseInt(this.max_placements.toString()) + 50;
        this.reload();
    }

    updateTopStorePlacements() {
        var selected_scope_value = this.getSelectedScopeValue();
        var placements = [];
        if (this.is_current_month) {
            if (this.mode == "daily") {
                placements = this.uscStoreService.generateTodaysStoreSalesQuotaPlacementsByScope(this.selected_scope_type.value, selected_scope_value, this.current_result_type);
            } else {
                placements = this.uscStoreService.generateStoreSalesQuotaPlacementsByScope(this.selected_scope_type.value, selected_scope_value, this.current_result_type);
            }
        } else {
            placements = this.uscStoreService.generateStoreSalesQuotaPlacementsFromPreviousActionPlans(this.selected_scope_type.value, selected_scope_value, this.scope_month, this.current_result_type);
        }
        this.top_placements = placements.slice(0, this.max_placements);
        this.show_view_more = this.top_placements.length < placements.length;
        var active_user_scope = this.getActiveUserScope();
        if (placements.length > this.top_placements.length) {
            var user_placement = placements.find(p => p.achievement[active_user_scope.scope_type] == active_user_scope.scope_value);
            if (user_placement && this.top_placements.find(p => p == user_placement) == null) {
                this.outside_placement = user_placement;
                this.show_outside_placement = true;
            }
        }
    }

    updateTopConsultantPlacements() {
        var selected_scope_value = this.getSelectedScopeValue();
        var available_placements = [];
        if (this.is_current_month) {
            if (this.mode == "daily") {
                available_placements = this.uscStoreService.generateTodaysConsultantPlacementsByScope(this.selected_scope_type.value, selected_scope_value);
            } else {
                available_placements = this.uscStoreService.generateConsultantPlacementsByScope(this.selected_scope_type.value, selected_scope_value);
            }
        } else {
            available_placements = this.uscStoreService.generateConsultantPlacementsFromPreviousActionPlans(this.selected_scope_type.value, selected_scope_value, this.scope_month);
        }

        var placements = [];
        // Agents Only - Exclude all associates that didn't submit their action plan
        if (this.uscStoreService.isUSCellAgent()) {
            available_placements.forEach(p => {
                if (p.achievement.ap_ID > 0 && (p.achievement.ap_status == this.uscStoreService.action_plan_status_requested || p.achievement.ap_status == this.uscStoreService.action_plan_status_approved)) placements.push(p);
            })
        } else {
            placements = available_placements;
        }

        this.top_placements = placements.slice(0, this.max_placements);
        this.show_view_more = this.top_placements.length < placements.length;
        if (!this.uscStoreService.isLeader()) {
            var user_placement = placements.find(p => p.achievement.CREATOR_ID == this.active_user.username);
            if (user_placement && this.top_placements.find(p => p == user_placement) == null) {
                this.outside_placement = user_placement;
                this.show_outside_placement = true;
            }
        }
    }

    getRank(placement) {
        var postfix = "th";
        if (placement.ranking < 11 || placement.ranking > 13) {
            var r = placement.ranking.toString();
            var last_digit = parseInt(r[r.length - 1]);
            switch (last_digit) {
                case 1: postfix = "st"; break;
                case 2: postfix = "nd"; break;
                case 3: postfix = "rd"; break;
            }
        }
        return placement.ranking.toString() + postfix;
    }

    getTitle() {
        var title = "Top _MP_ Monthly Results";
        if (this.mode == "daily") title = "Top _MP_ Daily Results";
        var scope_type = "";
        var max_placement = this.max_placements.toString();
        if (this.uscStoreService.isLeader()) {
            var scope_type = this.scope_type;
        } else if (this.user_achievement) {
            scope_type = this.selected_scope_type.name;
        }
        if (scope_type.toLowerCase() == "channel") scope_type = "National";
        if (scope_type.toLowerCase() == "store" && this.uscStoreService.isUSCellTelesales()) scope_type = "Pod";
        var formatted_scope_type = scope_type ? scope_type.replace(scope_type[0], scope_type[0].toUpperCase()) : "";
        return title.replace("_MP_", max_placement).replace("_ST_", formatted_scope_type);
    }

    getDesc() {
        if (!this.is_placement_loaded) return "Unable to determine the placements related to the current user.";
        var desc = "";
        if (this.uscStoreService.isLeader()) {
            desc = "Here are the TOP _MP_ weighted scorecard results:".replace("_MP_", this.max_placements.toString()).replace("_ST_", this.scope_value);
       } else if (this.user_achievement) {
            desc = "Here are the TOP _MP_ weighted scorecard results:";        
            desc = desc.replace("_MP_", this.max_placements.toString());
        }
        return desc;
    }

    public current_result_type = 'store';
    public view_result_types: string[] = [];
    switchToViewResultType(result_type) {
        this.max_placements = this.initial_max_placements;
        this.view_result_types = this.getAvailableViewResultTypes(result_type);
        this.current_result_type = result_type.toLowerCase();
        switch (result_type) {
            case "store": this.is_store_placement = true;  break;
            default: this.is_store_placement = false;
        }
        this.reload();
    }

    getAvailableViewResultTypes(exclude_type: string) {
        if (this.uscStoreService.isLeader()) {
            var view_result_types = [];
            var scope = this.getActiveUserScope();
            switch (scope.scope_type) {
                case "region": view_result_types = ['Region', 'Territory', 'Area', 'Store', 'Associate']; break;
                case "territory": view_result_types = ['Territory', 'Area', 'Store', 'Associate']; break;
                case "area": view_result_types = ['Area', 'Store', 'Associate']; break;
                case "store": view_result_types = ['Store', 'Associate']; break;
                case "agency": view_result_types = ['Store', 'Associate']; break;
            }
            var index = view_result_types.findIndex(t => t.toUpperCase() == exclude_type.toUpperCase());
            view_result_types.splice(index, 1);
        } else {
            view_result_types = []; 
        }
    return view_result_types;
    }

    switchToStoreResults() {
        this.is_store_placement = true;
        this.reload();
    }

    switchToAssociateResults() {
        this.is_store_placement = false;
        this.reload();
    }

    viewTodaysResults() {
        var content = { view: "todays_results", control_id: this.control_id };
        this.viewChange.emit(content);  
    }

    getPlacementStyle(placement) {
        var style = {}; 
        if (placement) {
            var active_user_scope = this.getActiveUserScope();
            if (active_user_scope && placement.achievement[active_user_scope.scope_type] == active_user_scope.scope_value) {
                style["background-color"] = "#FFBFD9";
            }
        }
        return style;
    }

    // public title_to_scope_type_mapping = [
    //     // corporate mapping
    //     { title: "VP - Retail Sales and Operations", scope_type: "channel" },
    //     { title: "Area VP-General Mgr, Retail Sales & Ops", scope_type: "region" },
    //     { title: "Dir Retail Sales and Operations", scope_type: "territory" },
    //     { title: "Mgr Retail Area Sales", scope_type: "area" },
    //     { title: "Store Mgr I", scope_type: "store" },
    //     { title: "Store Mgr II", scope_type: "store" },
    //     { title: "Mgr Store", scope_type: "store" },
    //     { title: "Mgr Sales", scope_type: "store" },
    //     { title: "Assistant Manager", scope_type: "store" },
    //     // telesales mapping
    //     { title: "VP - Customer Support", scope_type: "channel" },
    //     { title: "Mgr Telesales", scope_type: "channel" },
    //     { title: "Mgr Telesales", scope_type: "channel" },
    //     { title: "Telesales Supervisor", scope_type: "store" },
    //     // { title: "Telesales Supervisor2", scope_type: "store" },
    // ];

    // public getActiveUserScope() {
    //     var scope_user = this.active_user;
    //     var store_ID = this.uscStoreService.getItemCustomFieldValue(scope_user, "TopsID");
    //     var scope_mapping = this.title_to_scope_type_mapping.find(m => m.title == scope_user.title);
    //     if (scope_mapping == null) {
    //         scope_user = this.uscStoreService.getUserSupervisor(this.active_user);
    //     } 
    //     if (scope_user) {
    //         var scope_value = scope_user.first_name + ' ' + scope_user.last_name;
    //         // double check the scope_user title again         
    //         scope_mapping = this.title_to_scope_type_mapping.find(m => m.title == scope_user.title);
    //         if (scope_mapping) var scope_type = scope_mapping.scope_type; 
    //         // telesales supervisors have channel scope
    //         if (scope_type == "channel" && this.uscStoreService.isUSCellTelesales()) scope_value = "Telesales";
    //         if (scope_type == "store" && store_ID) {
    //             // if failed again, the this user must be in the scope_type = store            
    //             scope_value = this.uscStoreService.getStoreNameByStoreID(store_ID);
    //             scope_type = "store"; 
    //         }
    //     }
    //     if (!this.uscStoreService.isLeader()) {
    //         scope_type = 'CREATOR_ID';
    //         scope_value = this.active_user.username;
    //     }

    //     return { scope_type: scope_type, scope_value: scope_value };
    // }

    public getActiveUserScope() {
        var scope = this.uscStoreService.getDefaultScope(this.active_user);
        if (!this.uscStoreService.isLeader()) {
            scope.scope_type = 'CREATOR_ID';
            scope.scope_value = this.active_user.username;
        }

        return scope;
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-top10-result-panel/usc-top10-result-panel.component.ts